<template>
  
  <a-layout :style="{ background: 'none' }">
    <a-layout-header :style="{ background: 'none',height:'100px' }">
      
      <div class="left-actions">
        <a-space>
          <a-button type="primary" @click="handleButton">返回</a-button>
        </a-space>
        <a-space>
          <a-button type="primary" @click="exportData">导出excel</a-button>
        </a-space>
      </div>
      <div class="left-actions">
        <a-space>
          <p style="font-size: 20px;">任务详情</p>
        </a-space>
      </div>
    </a-layout-header>
    <a-layout :style="{ background: 'none' }">
      <a-layout-content>
        <a-space :style="{ width: '100%', display: 'flex', justifyContent: 'space-between'}">

          <a-card style="width: 100%" :style="{ background: 'none',border: 'none' }">  
            <div class="left-actions">
              <a-row>
                <a-col  style="width: 150px;">时间</a-col>
                <a-col  style="width: 150px;">发送者</a-col>
                <a-col  style="width: 150px;">接收者</a-col>
                <a-col  style="width: 150px;">接收者ID</a-col>
                <a-col  style="width: 260px;">状态</a-col>
              </a-row>
            </div>  
          </a-card>
        </a-space>


        <RecycleScroller
        ref="recycleScrollerRef"
        class="scroller"
        :items="taskLogList"
        :item-size="50"
        key-field="taskId"
        v-slot="{ item }"
      >
        <div class="item">
          <a-list-item
            :class="{ 'selected': selectedItem === item.taskId }"
            @click="handleItemClick(item)"
          >
            <a-row>
              <a-col  style="width: 150px;">{{ formatDateTime(item.sendTime) }}</a-col>
              <a-col  style="width: 150px;">{{ item.phone }}</a-col>
              <a-col  style="width: 150px;">{{ item.receiver }}</a-col>
              <a-col  style="width: 150px;">{{ item.receiver_id }}</a-col>
              <a-col  style="width: 260px;" :style="{ color: getColor(item.errCode) }">{{ item.errorMsg }}</a-col>
            </a-row>
          </a-list-item>
        </div>
      </RecycleScroller>


      </a-layout-content>
      <!-- <a-layout-sider :style="{ background: 'none' }"> -->
    <a-layout-sider :width="280" :style="{ background: 'none' }">   
      <a-list item-layout="horizontal" :data-source="taskRspList">
        <template #renderItem="{ item }">
                 <a-card :title = "getTaskName(item.index)" style="width: 200px" class="rounded-card">
                  <p>  {{ getTaskProgress(item.count,item.total) }}  </p>
                  <div style="width: 170px">
                    <a-progress :percent= getPercent(item.count,item.total) size="small" />
                  </div>
                </a-card>
        </template>
      </a-list>


      </a-layout-sider>
    </a-layout>
    <a-layout-footer :style="{ background: 'none' }">Footer</a-layout-footer>
  </a-layout>
  

</template>


<script setup lang="ts">
import { List } from 'ant-design-vue';
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { ref } from "vue";
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { TelegramClient } from "@/websocket/Client";
import * as telegram from "@/api/telegram";

import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { dataManager } from "@/common/dataManager";
const account = localStorage.getItem("username") || "";
const client = TelegramClient.getInstance();
const router = useRouter();
const recycleScrollerRef = ref(RecycleScroller);
 
const taskLogList = ref<telegram.tg.TaskLogItem[]>([]);
const taskRspList = ref<telegram.tg.MDM_GR_EXECUTE_TASK_RSP[]>([]);
const selectedItem = ref(0);
var taskUpdataLogList:any = [];
      //获取系统时间
      const formatDateTime =(sendTime)=> {

      var strTime =  new Date(Number(sendTime) * 1000).toLocaleString()

        return strTime
    }
 
      // 根据条件返回颜色
      const getColor =(errCode)=> {
        if(errCode === 0)
        {
            return '#52c41a';
        }
        else
        {
          return '#ff4d4f';
        }
    }

    const  getTaskName = (index)=>{
        var strName =  "任务索引" +  index ;
        return strName;
    }
 
    const  getPercent = (count,total)=>{
        var percent = Math.floor((parseInt(count)/parseInt(total)) * 100);
        return percent;
    }


    const  getTaskProgress = (count,total)=>{
        var strProgress = "私信" + "(" + count + "/" + total + ")";
        return strProgress;
    }
 

   // 处理列表项点击事件
    const handleItemClick = (item)=>{
      selectedItem.value = item.taskId; // 设置当前选中的列表项 ID
      console.log('Clicked item:', item);
    }
    
      const emit = defineEmits<{
    (e: "update:visible", visible: boolean): void;
  }>();

    const handleButton = ()=>{
      //recycleScrollerRef.value.scrollToItem(28);
      emit("update:visible", false);
  }

  const exportData = ()=>{
    var fileName = "export.xlsx";
    let copyArr = JSON.parse( JSON.stringify(taskUpdataLogList) );
    var jsonData = copyArr;
    for (let i = 0; i < jsonData.length; i++) {
        const element = jsonData[i];
        jsonData[i].sendTime = formatDateTime(element.sendTime);
     }
    if(jsonData.length > 0)
    {
      const worksheet = XLSX.utils.json_to_sheet(jsonData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, fileName);
    }

  }

  
  const handTaskUpdate = (data)=>{
    var newMessage = data.detail;
     //console.log('收到新消息:', newMessage);

     var bFind = false;
          for (let i = 0; i < taskRspList.value.length; i++) {
              const element = taskRspList.value[i];
              if(element.index == newMessage.index)
              {
                taskRspList.value[i] = newMessage;
                bFind = true;
                break;
              }
          }
          if(bFind)
          {

          }
          else
          {
              taskRspList.value.push(newMessage);
          }


     if(newMessage.errCode == 1)
     {

     }
     else
     {
        //搜索不到用户不能走日志这块。
        let nowTime = Math.floor(new Date().getTime() / 1000);
        let taskLost =  telegram.tg.TaskLogItem.create();   
        taskLost.taskId = new Date().getTime() + Math.random()*1000;
        taskLost.phone = newMessage.sender;
        taskLost.receiver = newMessage.receiver;
        taskLost.errorMsg = newMessage.reason;
        taskLost.errCode = -1000;
        taskLost.sendTime = nowTime;
        taskUpdataLogList.push(taskLost);
        taskLogList.value = taskUpdataLogList;
        recycleScrollerRef.value.handleResize();
        console.log("fdadfasdf round="+taskLost.taskId);
     }

     
  }

  const handTaskLogUpdate = (data)=>{
    var newMessage = data.detail;
    var bFind = false;
    console.log('收到新消息2:', newMessage);
    if(newMessage.errCode == 10000) return;
    if(newMessage.receiver == "")
    {
      //newMessage.receiver == newMessage.receiver_id;
    }
    for (let i = 0; i < taskUpdataLogList.length; i++) {
        const element = taskUpdataLogList[i];
        if(element.taskId == newMessage.taskId)
        {
          taskLogList.value[i] = newMessage;
           bFind = true;
           break;
        }
     }
     if(bFind)
     {

     }
     else
     {
       taskUpdataLogList.push(newMessage);
       taskLogList.value = taskUpdataLogList;
       recycleScrollerRef.value.handleResize();
     }

  }
 

  // 修改执行任务的处理函数
const handleViewLog = async (taskIds: number[]) => {
    const sesionId = localStorage.getItem("session") || "";
    client.getTaskLogEvent(account,sesionId);
    // dataManager.instance.taskLogList.value = response.list;
    // taskLogList.value = dataManager.instance.taskLogList.value;
    // console.log(response);

}


  onMounted(() => {
      //taskLogList.value = dataManager.instance.taskLogList.value;
      console.log("onMounted-1");
      taskUpdataLogList = [];
      const client = TelegramClient.getInstance();
      client.addTaskUpdateListener(handTaskUpdate);
      client.addTaskLogUpdateListener(handTaskLogUpdate);
      handleViewLog([0]);

  });

  
  onUnmounted(() => {
    client.removeTaskUpdateListener(handTaskUpdate);
    client.removeTaskLogUpdateListener(handTaskLogUpdate);
    });
 
</script>



<style scoped>
.scroller {
  height: 600px; /* 设置固定高度 */
  width: 98%; /* 设置固定高度 */
  border: 1px solid #e8e8e8;
  border-radius: 0px;
  padding: 0px;
}


.item {
  padding: 0px;
  border-bottom: 0px solid #e8e8e8;
}


.right-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.left-actions {
  display: flex;
  gap: 8px;
}

.selected {
  background-color: #e6f7ff; /* 选中项的背景色 */
}

.rounded-card {
  border-radius: 10px; /* 设置圆角 */
}
 
</style>